(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.an-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('an-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('an-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-an-contador]');
    if (!els.length) return;
    var animated = new WeakSet();
    var run = function (el) {
      if (animated.has(el)) return;
      animated.add(el);
      var target = parseFloat(el.getAttribute('data-an-contador')) || 0;
      var decimals = (el.getAttribute('data-an-decimales') || '0') === '1' ? 1 : 0;
      var suffix = el.getAttribute('data-an-sufijo') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target * eased;
        el.textContent = (decimals ? val.toFixed(1) : Math.round(val)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCarrusel(root) {
    var track = root.querySelector('[data-an-track]');
    var prev = root.querySelector('[data-an-prev]');
    var next = root.querySelector('[data-an-next]');
    if (!track) return;
    var scrollAmount = function () {
      var card = track.querySelector('[data-an-card]');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  }

  function initCarruseles() {
    document.querySelectorAll('[data-an-carrusel]').forEach(initCarrusel);
  }

  function initFaq() {
    document.querySelectorAll('[data-an-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-an-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('an-faq-open');
        item.closest('[data-an-faq]').querySelectorAll('[data-an-faq-item]').forEach(function (i) {
          i.classList.remove('an-faq-open');
          var b = i.querySelector('[data-an-faq-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('an-faq-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initTilt() {
    var cards = document.querySelectorAll('[data-an-tilt]');
    if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-an-galeria]').forEach(function (galeria) {
      var main = galeria.querySelector('[data-an-galeria-principal]');
      var thumbs = galeria.querySelectorAll('[data-an-galeria-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-full');
          var srcset = thumb.getAttribute('data-full-srcset');
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
          thumbs.forEach(function (t) { t.classList.remove('an-thumb-activa'); });
          thumb.classList.add('an-thumb-activa');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-an-producto-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-an-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var opcionInputs = form.querySelectorAll('[data-an-opcion]');
      var idInput = form.querySelector('[data-an-variant-id]');
      var precioEl = form.querySelector('[data-an-precio]');
      var compareEl = form.querySelector('[data-an-precio-comparado]');
      var addBtn = form.querySelector('[data-an-add]');

      function moneda(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }

      function obtenerValoresSeleccionados() {
        var grupos = {};
        var orden = [];
        Array.prototype.forEach.call(opcionInputs, function (input) {
          if (!(input.name in grupos)) { grupos[input.name] = null; orden.push(input.name); }
          if (input.type !== 'radio' && input.type !== 'checkbox') { grupos[input.name] = input.value; }
          else if (input.checked) { grupos[input.name] = input.value; }
        });
        return orden.map(function (name) { return grupos[name]; });
      }

      function actualizar() {
        var valores = obtenerValoresSeleccionados();
        var match = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (precioEl) precioEl.textContent = moneda(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = moneda(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (match.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-text-disponible') || addBtn.textContent;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-text-agotado') || 'Agotado';
          }
        }
        if (match.featured_image) {
          var galeriaPrincipal = document.querySelector('[data-an-galeria-principal]');
          if (galeriaPrincipal) {
            galeriaPrincipal.src = match.featured_image.src;
            galeriaPrincipal.srcset = match.featured_image.srcset || '';
            galeriaPrincipal.alt = match.featured_image.alt || galeriaPrincipal.alt;
          }
          document.querySelectorAll('[data-an-galeria-thumb]').forEach(function (thumb) {
            var esta = thumb.getAttribute('data-full') === match.featured_image.src;
            thumb.classList.toggle('an-thumb-activa', esta);
          });
        }
      }
      Array.prototype.forEach.call(opcionInputs, function (input) { input.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initCarruseles();
    initFaq();
    initTilt();
    initGaleriaProducto();
    initVariantes();
  });
})();
